import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/tools/ToolShell";

export const Route = createFileRoute("/fr/about")({
  head: () => ({
    meta: [
      { title: "À propos de Picamini.online — Outils Gratuits et Privés" },
      {
        name: "description",
        content: "Découvrez la mission de Picamini.online : offrir des outils de tirage au sort, roues de la fortune et utilitaires PDF 100% gratuits dans votre navigateur.",
      },
    ],
    links: [
      { rel: "canonical", href: "https://picamini.online/fr/a-propos" },
      { rel: "alternate", hrefLang: "en", href: "https://picamini.online/about" },
      { rel: "alternate", hrefLang: "es", href: "https://picamini.online/es/sobre-nosotros" },
      { rel: "alternate", hrefLang: "de", href: "https://picamini.online/de/ueber-uns" },
      { rel: "alternate", hrefLang: "pt-BR", href: "https://picamini.online/pt-br/sobre-o-picamini" },
      { rel: "alternate", hrefLang: "fr", href: "https://picamini.online/fr/a-propos" },
      { rel: "alternate", hrefLang: "x-default", href: "https://picamini.online/about" },
    ],
  }),
  component: FrAboutPage,
});

function FrAboutPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col font-sans">
      <SiteHeader lang="fr" />

      <main className="flex-1 py-12 mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 space-y-6">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-foreground">À propos de Picamini.online</h1>

        <p className="text-base text-muted-foreground leading-relaxed">
          <strong>Picamini.online</strong> est une plateforme indépendante dédiée à la création d'outils interactifs de tirage au sort, de roues de la fortune et d'utilitaires PDF 100% gratuits, rapides et respectueux de la vie privée.
        </p>

        <h2 className="text-xl font-bold text-foreground pt-4">Notre Mission</h2>
        <p className="text-base text-muted-foreground leading-relaxed">
          Nous sommes convaincus que les enseignants, étudiants et animateurs ne devraient pas avoir à payer des abonnements coûteux ou créer des comptes complexes simplement pour tirer un prénom au sort, tourner une roue ou fusionner deux fichiers PDF. Tous nos outils s'exécutent directement dans le navigateur, sans téléversement de fichiers ni collecte de données personnelles.
        </p>

        <h2 className="text-xl font-bold text-foreground pt-4">La Confidentialité Avant Tout</h2>
        <p className="text-base text-muted-foreground leading-relaxed">
          Notre suite PDF Toolkit Pro effectue toutes les éditions et conversions de documents en utilisant les technologies WebAssembly et JavaScript directement sur votre appareil. Vos fichiers ne quittent jamais votre ordinateur ou votre téléphone.
        </p>
      </main>

      <SiteFooter lang="fr" />
    </div>
  );
}
